import { capitalize } from "lodash";
import { Modal } from "reactstrap"
import React from "react";
import KickImage from 'Reuseables/KickImage';
import ReactDOM from "react-dom";
import ArrowSpin from "../../images/spin-arrow-cny.png"
import SpinLogo from "../../images/logo-cny.png"
import SpinCoin from "../../images/spin-coin.png"
import NoCoin from "../../images/no-coins.png"
import SpinReward from "../../images/cny-prize.png"
import SpinBorder from "../../images/border-10.svg"
import CloseIcon from '../../images/close-button-black.png';
import SpinBorder4 from "../../images/border-4.svg"
import { getCloudImageUrl } from "../../utils/Helpers"
import SpinBorder6 from "../../images/border-6.svg"
import SpinBorder8 from "../../images/border-8.svg"
import { getSpinningWheel, getSpinningWheelPrize, postSpinningWheel } from "../../actions/productAction"
import { connect } from "react-redux"
import ModalLoginNew from "../Modals/ModalLoginNew"

import { withRouter, history } from "react-router-dom"
class PageSpinningWheel extends React.Component {
  state = {
    list: [],
    radius: 75, // PIXELS
    rotate: 0, // DEGREES
    easeOut: 0, // SECONDS
    angle: 0, // RADIANS
    top: null, // INDEX
    offset: null, // RADIANS
    net: null, // RADIANS
    result: null, // INDEX
    spinning: false,
    showModalLogin: false,
    showModalError: false,
    wheelTitle: "",
    wheelDescription: "",
    wheelId: 0,
    wheelResultIndex: 0,
    wheelResultName: "",
    wheelResultImage: "",
    wheelError: "",
  };

  componentDidMount() {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });

    this.renderWheel()

    if (this.props.isLoggedIn) {
      this.setState({ showModalLogin: false }, () => this.renderWheel())
    } else {
      this.props.history.push({
        pathname: "/login",
        state: {
          isFromRafflePage: true,
          redirectPath: this.props.history.location.pathname,
        }
      });
    }
  }

  componentDidUpdate() {
    if (this.props.isLoggedIn) {
      this.setState({ showModalLogin: false }, () => this.renderWheel())
    } else {
      this.setState({ showModalLogin: true })
    }
  }

  renderWheel() {
    this.props.getSpinningWheel()
      .then(res => {
        this.setState({
          wheelTitle: res.value.data[0].title,
          wheelDescription: res.value.data[0].description,
          wheelId: res.value.data[0].id
        })
      })
      .then(_ => {
        return this.props.getSpinningWheelPrize(this.state.wheelId)
      })
      .then(res => {
        return this.setState({
          list: res.value.data.prizes,
          coin: res.value.data.coin
        })
      })
      .then(_ => {
        let numOptions = this.state.list.length;
        let arcSize = (2 * Math.PI) / numOptions;
        const { getSpinningWheel, getSpinningWheelPrize } = this.props

        this.setState({
          angle: arcSize
        });

        // get index of starting position of selector
        this.topPosition(numOptions, arcSize);

        // dynamically generate sectors from state list
        let angle = 0;
        for (let i = 0; i < numOptions; i++) {
          let image = getCloudImageUrl(this.state.list[i].image, 200)

          this.renderSector(i + 1, angle, arcSize, i % 2 === 0 ? "#d01540" : "rgb(255, 255, 255)", image);
          angle += arcSize;
        }

      })
      .catch(e => null)
  }

  topPosition = (num, angle) => {
    // set starting index and angle offset based on list length
    // works upto 9 options
    let topSpot = null;
    let degreesOff = null;
    if (num === 10) {
      topSpot = 7;
      degreesOff = Math.PI / 2 - angle * 2;
    } else if (num === 8) {
      topSpot = 6;
      degreesOff = 0;
    } else if (num <= 7 && num > 4) {
      topSpot = num - 1;
      degreesOff = Math.PI / 2 - angle;
    } else if (num === 4) {
      topSpot = num - 1;
      degreesOff = 0;
    } else if (num <= 3) {
      topSpot = num;
      degreesOff = Math.PI / 2;
    }

    this.setState({
      top: topSpot - 1,
      offset: degreesOff
    });
  };

  renderSector(index, start, arc, color, wheelImage) {
    // create canvas arc for each list element
    let canvas = document.getElementById("wheel");
    let ctx = canvas.getContext("2d");
    let x = canvas.width / 2;
    let y = canvas.height / 2;
    let radius = this.state.radius;
    let startAngle = start;
    let endAngle = start + arc;
    let angle = index * arc;
    let baseSize = radius * 3.33;
    let textRadius = baseSize - 150;

    ctx.beginPath();
    ctx.arc(x, y, radius, startAngle, endAngle, false);
    ctx.lineWidth = radius * 2;
    ctx.strokeStyle = color;

    ctx.font = "9px Nunito Regular";
    ctx.fillStyle = "#fff";
    ctx.stroke();

    ctx.save();
    ctx.translate(
      baseSize + Math.cos(angle - arc / 2) * textRadius,
      baseSize + Math.sin(angle - arc / 2) * textRadius
    );

    ctx.rotate(angle - arc / 2 + Math.PI / 2);
    ctx.restore();
  }

  spin = () => {
    this.setState({
      spinning: true
    })
    // set random spin degree and ease out time
    // set state variables to initiate animation
    this.props.postSpinningWheel({ spinning_wheel_id: this.state.wheelId })
      .then(res => {
        if (res.value.response) {
          this.setState({
            wheelError: res.value.response.data.error.message,
            showModalError: !this.state.showModalError,
            spinning: false
          })
        } else {
          for (let i = 0; i < this.state.list.length; i++) {
            if (this.state.list[i].slug === res.value.data.data.slug) {
              return { index: i + 1, name: this.state.list[i].name, image: this.state.list[i].image }
            }
          }
        }
      })
      .then(data => {
        if (!data) return null

        this.setState({
          wheelResultIndex: data.index,
        })


        let rotationDivider = Number((this.state.wheelResultIndex / this.state.list.length).toFixed(1))

        let randomSpin = 0;

        if (this.state.list.length === 6) {
          randomSpin = ((rotationDivider - 0.1) * 360 + (this.state.rotate - 30) + 1800 - (this.state.rotate % 360));
        } else if (this.state.list.length === 8) {
          randomSpin = ((rotationDivider - 0.1) * 360 + (this.state.rotate + 15) + 1800 - (this.state.rotate % 360));
        } else {
          randomSpin = ((rotationDivider - 0.1) * 360 + (this.state.rotate) + 1800 - (this.state.rotate % 360));
        }

        this.setState({
          rotate: -randomSpin,
        })

        setTimeout(() => {
          this.getResult(randomSpin, data.index, data.name, data.image);
        }, 4000);
      })
      .catch(e => null)
  };

  exitModalResult = () => {
    this.setState({
      claim: true
    })

    setTimeout(() => {
      this.setState({
        claim: false,
        result: null
      })
    }, 1000)
  }

  componentDidUpdate = () => {
    let { result } = this.state

    if (result || result === 0) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
  getResult = (spin, index, name, image) => {
    // find net rotation and add to offset angle
    // repeat substraction of inner angle amount from total distance traversed
    // use count as an index to find value of result from state list
    const { angle, top, offset, list } = this.state;
    let netRotation = ((spin % 360) * Math.PI) / 180; // RADIANS
    let travel = netRotation + offset;
    let count = 0
    if (this.state.list.length === 10) {
      count = top + 2
    } else if (this.state.list.length === 8) {
      count = top + 1
    } else if (this.state.list.length === 6) {
      count = top
    } else if (this.state.list.length === 4) {
      count = top + 1
    }
    while (travel > 0) {
      travel = travel - angle;
      count--;
    }
    let result;
    if (count >= 0) {
      result = count;
    } else {
      result = list.length + count;
    }

    // set state variable to display result
    this.setState({
      net: netRotation,
      result: result,
      wheelResultName: name,
      wheelResultImage: image
    }, () => {
      this.props.getSpinningWheelPrize(this.state.wheelId)
        .then(res => {
          this.setState({
            coin: res.value.data.coin,
            spinning: false,
          })
        })
        .catch(e => {
          this.closeModalError()
        })
    });
  };

  redirectAfterAuth = () => {
    if (this.props.isLoggedIn) {
      this.setState({
        showModalLogin: false
      }, () => this.renderWheel())
      this.props.history.replace("/spinthewheel")
    } else {
      this.setState({
        showModalLogin: false
      })
      this.props.history.replace("/")
    }
  }

  closeModalError = () => {
    this.setState({
      showModalError: !this.state.showModalError
    })
  }

  redirectToMyVoucher = () => {
    this.props.history.replace("/user_dashboard/rewards")
  }

  render() {
    return (
      <div className="spin-the-wheel">
        {
          this.state.showModalError ? <Modal className="spin-wheel-modal-err" isOpen={this.state.showModalError} toggle={this.closeModalError}>
            <KickImage onClick={() => this.closeModalError()} className="error-btn" src={CloseIcon} alt="close modal" />
            <div>
              <KickImage src={NoCoin} alt="" />
              <h4>{this.state.wheelError === "You have no more coin" ? "You don't have enough coins" : this.state.wheelError}</h4>
              <h6>You need at least 1 coin to participate, earn more coins by purchasing any products in Kick Avenue.</h6>
            </div>
          </Modal> : null
        }
        {
          this.state.showModalLogin ? <ModalLoginNew isOpen={this.state.showModalLogin} onClosed={this.redirectAfterAuth} /> : null
        }
        {
          (this.state.result || this.state.result === 0) && <div
            className="claim-spin"
          >
            <div className="claim-zoom">
              <h4>Congratulations!</h4>
              <KickImage className={this.state.claim ? "claim-minizoom" : "claim-maxizoom"} src={getCloudImageUrl(this.state.wheelResultImage, 250) || getCloudImageUrl(SpinReward, 250)} alt="reward" />
              <h6>You got {this.state.wheelResultName}!</h6>
            </div>
            <button className="btn-claim" onClick={this.exitModalResult}>CLAIM</button>
          </div>
        }
        {
          window.screen.availWidth >= 720 ? <div className="spin-widget">
            <div className="voucher-coin">
              <KickImage src={SpinCoin} alt="coin" />
              <h6>{this.state.coin || "0"}</h6>
            </div>
            <div onClick={() => this.redirectToMyVoucher()} className="reward-container">
              <KickImage className="reward-box" src={SpinReward} alt="reward box" />
              <h4>My Prizes</h4>
            </div>
          </div> : <div className="spin-sm-widget">
            <div className="reward-container">
              <div onClick={() => this.redirectToMyVoucher()} className="reward-button">
                <KickImage className="reward-box" src={SpinReward} alt="reward box" />
                <h4>My Prizes</h4>
              </div>
            </div>
            <div className="voucher-coin-container">
              <div className="voucher-coin">
                <KickImage src={SpinCoin} alt="coin" />
                <h6>{this.state.coin || "0"}</h6>
              </div>
            </div>
          </div>
        }
        <div className="spin-header">
          <h1>{this.state.wheelTitle.toUpperCase()}</h1>
          <h4>{this.state.wheelDescription}</h4>
        </div>
        <div className="wheel-container">
          <KickImage className="wheel-selector" src={ArrowSpin} alt="" />
          <KickImage className="wheel-rotator" src={SpinLogo} alt="" />
          {
            this.state.list.length > 0 ? <KickImage style={{
              WebkitTransform: `rotate(${this.state.rotate}deg)`,
              WebkitTransition: `-webkit-transform ${4
                }s ease-out`,
            }} src={this.state.list.length === 10 ? SpinBorder : this.state.list.length === 8 ? SpinBorder8 : this.state.list.length === 6 ? SpinBorder6 : SpinBorder4} className="spin-wheel-border" alt="wheel border" /> : null
          }
          {
            this.state.list.length > 0 ?
              <div
                style={window.screen.availWidth > 720 ? {
                  WebkitTransform: `rotate(${this.state.rotate}deg)`,
                  WebkitTransition: `-webkit-transform ${4
                    }s ease-out`,
                  zIndex: "1",
                  position: "absolute",
                  width: "300px",
                  height: "300px",
                  margin: "auto",
                  top: 0,
                  bottom: 0,
                  left: 0,
                  right: 0
                } : {
                  WebkitTransform: `rotate(${this.state.rotate}deg)`,
                  WebkitTransition: `-webkit-transform ${4
                    }s ease-out`,
                  zIndex: "1",
                  position: "absolute",
                  width: "300px",
                  height: "300px",
                  margin: "auto",
                  top: 0,
                  bottom: 0,
                  left: 0,
                  right: 0,
                  marginTop: 0
                }}
              >
                {
                  this.state.list.map((item, i) => (
                    <KickImage key={i} src={getCloudImageUrl(item.image, 60)} alt="Prize image" width="45" height="45"
                      style={
                        this.state.list.length === 10 ?
                          {
                            WebkitTransform: `rotate(${(360 / this.state.list.length) * i}deg)`,
                            position: "absolute",
                            margin: "auto",
                            top: i === 0 ? 20 : i === 1 || i === 9 ? 35 : i === 6 ? 210 : i === 5 ? 230 : i === 2 || i === 8 ? 95 : i === 3 || i === 7 ? 160 : i === 4 ? 215 : 150,
                            left: i === 0 || i === 5 ? 130 : i === 1 ? 195 : i === 9 ? 65 : i === 2 || i === 3 ? 235 : i === 7 || i === 8 ? 25 : i === 4 ? 190 : i === 6 ? 65 : 0
                          } : this.state.list.length === 8 ? {
                            WebkitTransform: `rotate(${(360 / this.state.list.length) * (i + i === 0 ? 8.5 : i === 1 ? 9.25 : i === 2 ? 10.5 : i === 3 ? 11.5 : i === 4 ? 12.5 : i === 5 ? 13.5 : i === 6 ? 14.5 : 15.25)}deg)`,
                            position: "absolute",
                            margin: "auto",
                            top: i === 0 ? 30 : i === 1 ? 80 : i === 6 ? 85 : i === 5 ? 155 : i === 2 ? 155 : i === 3 ? 210 : i === 4 ? 205 : 30,
                            left: i === 0 || i === 3 ? 155 : i === 1 ? 210 : i === 6 ? 35 : i === 2 ? 210 : i === 4 ? 85 : i === 5 ? 35 : 85
                          } : this.state.list.length === 6 ? {
                            WebkitTransform: `rotate(${(360 / this.state.list.length) * (i)}deg)`,
                            position: "absolute",
                            margin: "auto",
                            top: i === 0 ? 30 : i === 1 ? 70 : i === 5 ? 75 : i === 2 ? 160 : i === 3 ? 210 : i === 4 ? 165 : 10,
                            left: i === 0 || i === 3 ? 120 : i === 1 ? 200 : i === 3 ? 220 : i === 4 ? 35 : i === 5 ? 45 : 200
                          } : {
                            WebkitTransform: `rotate(${(360 / this.state.list.length) * (i + i === 0 ? 8.5 : i === 1 ? 9.5 : i === 2 ? 10.5 : 11.5)}deg)`,
                            position: "absolute",
                            margin: "auto",
                            top: i === 0 ? 60 : i === 1 ? 190 : i === 2 ? 190 : 60,
                            left: i === 0 ? 190 : i === 1 ? 190 : i === 2 ? 50 : 60
                          }
                      }
                    />
                  ))
                }
              </div> : null
          }
          <canvas
            id="wheel"
            width={window.screen.availWidth >= 320 && window.screen.availWidth <= 720 ? "300" : "500"}
            height={window.screen.availWidth >= 320 && window.screen.availWidth <= 720 ? "300" : "500"}
            style={{
              WebkitTransform: `rotate(${this.state.rotate}deg)`,
              WebkitTransition: `-webkit-transform ${4
                }s ease-out`,
            }}
          />
        </div>
        <button className="btn-spin-wheel" onClick={!this.state.spinning ? this.spin : null}>SPIN</button>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isLoggedIn: state.dataAuth.isLogged,
})

const mapDispatchToProps = dispatch => ({
  getSpinningWheel: () => dispatch(getSpinningWheel()),
  postSpinningWheel: (payload) => dispatch(postSpinningWheel(payload)),
  getSpinningWheelPrize: (id) => dispatch(getSpinningWheelPrize(id))
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PageSpinningWheel))